import React, { useState } from 'react';
import './ReactDatepicker.scss';
import { DatePicker } from 'antd';
import { useContext } from "react";
// import { THEME_DARK, THEME_LIGHT } from '../../../context/ThemeContext/actions';
// import ThemeContext from '../../../context/ThemeContext/store/ThemeContext';
import { useEffect } from 'react';
import moment from 'moment';
import { useRef } from 'react';
import commonFunctionObject from '../../../common-function';
import PropTypes from 'prop-types'

const Datepicker = ({ placeholder, onChange, value, error, errorSpace, defaultValue, name, dateLimit, format }) => {
    console.log("datepicker", typeof value)
    // const [themeState] = useContext(ThemeContext)
    const [calendarState, setCalendarState] = useState(false)
    const datepickerIcon = () => {
        return (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.7917 0.5C13.51 0.5 14.1988 0.785341 14.7067 1.29325C15.2147 1.80116 15.5 2.49004 15.5 3.20833V12.7917C15.5 13.51 15.2147 14.1988 14.7067 14.7067C14.1988 15.2147 13.51 15.5 12.7917 15.5H3.20833C2.49004 15.5 1.80116 15.2147 1.29325 14.7067C0.785341 14.1988 0.5 13.51 0.5 12.7917V3.20833C0.5 2.49004 0.785341 1.80116 1.29325 1.29325C1.80116 0.785341 2.49004 0.5 3.20833 0.5H12.7917ZM14.25 5.08333H1.75V12.7917C1.75 13.5967 2.40333 14.25 3.20833 14.25H12.7917C13.1784 14.25 13.5494 14.0964 13.8229 13.8229C14.0964 13.5494 14.25 13.1784 14.25 12.7917V5.08333ZM4.45833 10.0833C4.7346 10.0833 4.99955 10.1931 5.1949 10.3884C5.39025 10.5838 5.5 10.8487 5.5 11.125C5.5 11.4013 5.39025 11.6662 5.1949 11.8616C4.99955 12.0569 4.7346 12.1667 4.45833 12.1667C4.18207 12.1667 3.91711 12.0569 3.72176 11.8616C3.52641 11.6662 3.41667 11.4013 3.41667 11.125C3.41667 10.8487 3.52641 10.5838 3.72176 10.3884C3.91711 10.1931 4.18207 10.0833 4.45833 10.0833ZM8 10.0833C8.27627 10.0833 8.54122 10.1931 8.73657 10.3884C8.93192 10.5838 9.04167 10.8487 9.04167 11.125C9.04167 11.4013 8.93192 11.6662 8.73657 11.8616C8.54122 12.0569 8.27627 12.1667 8 12.1667C7.72373 12.1667 7.45878 12.0569 7.26343 11.8616C7.06808 11.6662 6.95833 11.4013 6.95833 11.125C6.95833 10.8487 7.06808 10.5838 7.26343 10.3884C7.45878 10.1931 7.72373 10.0833 8 10.0833ZM4.45833 6.75C4.7346 6.75 4.99955 6.85975 5.1949 7.0551C5.39025 7.25045 5.5 7.5154 5.5 7.79167C5.5 8.06793 5.39025 8.33289 5.1949 8.52824C4.99955 8.72359 4.7346 8.83333 4.45833 8.83333C4.18207 8.83333 3.91711 8.72359 3.72176 8.52824C3.52641 8.33289 3.41667 8.06793 3.41667 7.79167C3.41667 7.5154 3.52641 7.25045 3.72176 7.0551C3.91711 6.85975 4.18207 6.75 4.45833 6.75ZM8 6.75C8.27627 6.75 8.54122 6.85975 8.73657 7.0551C8.93192 7.25045 9.04167 7.5154 9.04167 7.79167C9.04167 8.06793 8.93192 8.33289 8.73657 8.52824C8.54122 8.72359 8.27627 8.83333 8 8.83333C7.72373 8.83333 7.45878 8.72359 7.26343 8.52824C7.06808 8.33289 6.95833 8.06793 6.95833 7.79167C6.95833 7.5154 7.06808 7.25045 7.26343 7.0551C7.45878 6.85975 7.72373 6.75 8 6.75ZM11.5417 6.75C11.8179 6.75 12.0829 6.85975 12.2782 7.0551C12.4736 7.25045 12.5833 7.5154 12.5833 7.79167C12.5833 8.06793 12.4736 8.33289 12.2782 8.52824C12.0829 8.72359 11.8179 8.83333 11.5417 8.83333C11.2654 8.83333 11.0004 8.72359 10.8051 8.52824C10.6097 8.33289 10.5 8.06793 10.5 7.79167C10.5 7.5154 10.6097 7.25045 10.8051 7.0551C11.0004 6.85975 11.2654 6.75 11.5417 6.75ZM12.7917 1.75H3.20833C2.82156 1.75 2.45063 1.90365 2.17714 2.17714C1.90365 2.45063 1.75 2.82156 1.75 3.20833V3.83333H14.25V3.20833C14.25 2.82156 14.0964 2.45063 13.8229 2.17714C13.5494 1.90365 13.1784 1.75 12.7917 1.75Z" fill="#95A5BF" />
            </svg>

        )
    }
    function disabledDate(current) {
        // Can not select days before today and today
        // Date conditions
        if (dateLimit) {
            // Future Date 
            if (dateLimit === "futuredate") {
                return current && current < moment().endOf('day');
            }
            else {
                // 18 Year old date conditions
                var eighteenYearsAgo = new Date();
                eighteenYearsAgo = eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);
                var eighteenYears = new Date(eighteenYearsAgo);
                return moment(eighteenYears, "YYYY-MM-DD").endOf('day') <= current
            }
        } else {
            // Past Date
            return current && current > moment().endOf('day');
        }
    }

    const setDate = (date) => {
        onChange(date)
    }

    return (
        <>
            <div className={`THEME_LIGHT`} style={{ borderRadius: "9px" }}>
                <div className={`multi-datepicker-container`} >
                    <div className='multi-datepicker-input'>
                        <DatePicker name={name} onClick={() => { setCalendarState(true) }} disabledDate={disabledDate} popupClassName={""} className={""} format={format ? format : "YYYY/MM/DD"} placeholder={placeholder} value={value} defaultValue={defaultValue ? moment(defaultValue) : ""} onChange={(date) => { setDate(date) }} defaultPickerValue="" />
                    </div>
                    {/* <div className='date-picker-calendar' onClick={() => setCalendarState(true)}>
                        <img src='assets/images/datepicker-icon.svg' style={{ height: 15, width: 15, }} />
                    </div> */}
                    <div className='date-picker-input-error' ></div>
                </div>
            </div>
            {
                errorSpace ?
                    <div className="error-span">
                        <span>{error}</span>
                    </div>
                    : null

            }
        </>


    )
}

Datepicker.propTypes = {
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    error: PropTypes.string,
    errorSpace: PropTypes.bool,
    defaultValue: PropTypes.string,
    name: PropTypes.string,
    dateLimit: PropTypes.bool,
    format: PropTypes.string,
}

export default Datepicker;